import {type UseFormReset} from "react-hook-form";
import {type Configuration} from "../types";
import {useEffect} from "react";

export const resetValidation = (values: Configuration, reset: UseFormReset<Configuration>) => {
  useEffect(() => {
    if (values?.file?.length === 0) {
      reset(
        {...values, file: undefined},
        {
          keepErrors: true,
          keepDirty: true,
          keepDirtyValues: true,
          keepTouched: true,
          keepDefaultValues: true
        }
      );
    }
  }, [reset, values]);
};
